import React from 'react';

const Footer = () => <footer className="footer p-3 text-center"></footer>;

export default Footer;
